import { useLocale } from '../hooks/useLocale'
import styles from './Footer.module.css'

export default function Footer() {
  const { t } = useLocale()

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <nav className={styles.footerNav}>
          <a href="#hero" className={styles.footerLink}>
            {t('footer.links.home')}
          </a>
          <a href="#about" className={styles.footerLink}>
            {t('footer.links.about')}
          </a>
          <a href="#services" className={styles.footerLink}>
            {t('footer.links.services')}
          </a>
          <a href="#expertise" className={styles.footerLink}>
            {t('footer.links.expertise')}
          </a>
          <a href="#contact" className={styles.footerLink}>
            {t('footer.links.contact')}
          </a>
        </nav>
        <div className={styles.copyright}>
          {t('footer.copyright')}
        </div>
      </div>
    </footer>
  )
}
